import { HTTP } from '@/common/utils/http';
import { PaginationParams } from '@/common/utils/pagination-params';
import { QueryParams} from '@/common/utils/query-params';

export const SchoolCampService = {
    createCamp(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/camps`, form);
    },

    editCamp(schoolId, campId, form) {
        return HTTP.put(`/schools/${schoolId}/camps/${campId}`, form);
    },

    getCamps(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/no-auth/schools/${schoolId}/camps`);
        return HTTP.get(url);
    },

    getCampsByInstructor(schoolId, instructorId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/camps/instructor/${instructorId}`);
        return HTTP.get(url);
    },

    getCampsGeneralInfo(schoolId) {
        return HTTP.get(`/schools/${schoolId}/camps/statistics`);
    },

    getCampDetailsGeneralInfo(schoolId, campPricingId) {
        return HTTP.get(`/schools/${schoolId}/camp-pricing/${campPricingId}/rosters/statistics`);
    },

    addToWaitList(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/camps/wait-list`, form);
    },

    getCamp(schoolId, campId) {
        return HTTP.get(`/schools/${schoolId}/camps/${campId}`);
    },

    deleteCamp(schoolId, campId) {
        return HTTP.delete(`/schools/${schoolId}/camps/${campId}`);
    },

    deleteMultipleCamps(schoolId, campIds) {
        return HTTP.delete(`/schools/${schoolId}/camps?ids=${campIds}`);
    },

    bulkUpdateCamps(schoolId, campIds, form) {
        const body = {
            ids: campIds,
            ...form
        };
        return HTTP.patch(`/schools/${schoolId}/camps`, body);
    },

    getCampsByDate(schoolId, date, timezone) {
        return HTTP.get(`/schools/${schoolId}/camps/dashboard?filterDate=${date}&timeZone=${timezone}`);
    },

    sendBulkEmail(schoolId, body, attachment) {
        const headers = {
            'Content-type': 'multipart/form-data'
        };
        const formData = new FormData();
        const form = JSON.stringify(body);
        formData.append("emailForm", form);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`/schools/${schoolId}/camps/parent-emails`, formData, { headers });
    },

    sendBulkSMS(schoolId, body) {
        return HTTP.post(`/schools/${schoolId}/camps/parent-sms`, body);
    },

    getXlsFileFieldNames(schoolId) {
        return HTTP.get(`/schools/${schoolId}/camps/xls-fields`);
    },

    getCampsBySchoolXls(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/camps/xls`, form);
    },

    getCampsBySchoolXlsBySchedule(schoolId, ids) {
        return HTTP.get(`/schools/${schoolId}/camps/schedule?ids=${ids}`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/pages/camps.service.js